import type { SxProps, Theme } from '@mui/material'

export const styles = {
  title: {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: ({ spacing }) => spacing(1),
  },
} satisfies Record<string, SxProps<Theme>>
